// api/auth.js
import Configurator from "../../config/Configurator.js";

export async function login(email, password) {
  if (!email || !password) {
    return { ok: false, error: "Please fill in all fields!" };
  }

  const { API_URL } = await Configurator();

  // 10s timeout
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 30_000);

  try {
    const res = await fetch(`${API_URL}/v2/io/users/auth`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Session: localStorage.getItem("apiKey") ?? "",
        "User-Id": localStorage.getItem("userID") ?? "",
      },
      body: JSON.stringify({
        data: { name: email, pass: password },
        metadata: {},
      }),
      signal: controller.signal,
    });

    clearTimeout(timer);

    if (!res.ok) {
      return { ok: false, error: `Incorrect email or password!` };
    }

    const json = await res.json();

    if (json?.data?.auth) {
      persistSession({ id: json.data.id, session: json.data.session, email });
      window.simulationData = {};
      return { ok: true };
    }

    return { ok: false, error: "Incorrect email or password!" };
  } catch (err) {
    clearTimeout(timer);
    clearSession();

    if (err?.name === "AbortError") {
      return { ok: false, error: "Timeout occurred!" };
    }

    console.error("Login error:", err);
    return { ok: false, error: "Error during request!" };
  }
}

function persistSession({ id, session, email }) {
  localStorage.setItem("userID", id);
  localStorage.setItem("apiKey", session);
  localStorage.setItem("userName", email);
}

function clearSession() {
  localStorage.clear();
  sessionStorage.clear();
}
